import styled from 'styled-components';
import { secondaryFont, mainFont } from 'components/mixins/typography';
import Icon from 'components/common/Icon';
import { transparentize } from 'utils/color';
import { Button, Text } from 'components/common';

type PopoverContentWrapperProps = {
  ariaModal: boolean;
};
export const PopoverContentWrapper = styled.div<PopoverContentWrapperProps>`
  ${secondaryFont};
  line-height: 2;
  padding: 4px 6px 6px;
  text-align: center;
  outline: none;
  color: ${props => {
    return props.theme.colors.textColor;
  }};
  font-size: 14px;
  background: ${props => props.theme.colors.contentBodyColor};
  max-height: 70vh;
  overflow: hidden;
`;

export const SubmitMessageWrapper = styled.div``;

export const PopoverContent = styled.div`
  width: 240px;
  min-height: 310px;
  padding: 35px 20px 19px;
`;

export const ClosePopoverIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 24px;
  color: ${props =>
    transparentize(props.theme.colors.textColor, props.theme.themeUtils.getOpacity(true, 0.2))};
  transition: 0.2s;

  &:hover {
    color: ${props => props.theme.colors.textColor};
  }
`;

export const PopoverButton = styled(Button)`
  height: 40px;

  &:first-of-type {
    margin-bottom: 20px;
  }
`;
export const PopoverContentHeader = styled(Text)`
  margin: 24px 0 12px;
`;
export const PopoverContentMessage = styled.span`
  ${mainFont};
  font-weight: normal;
  display: block;
  margin: 0 0 12px;
  font-size: 15px;
  line-height: 1.4;
  color: ${props => props.theme.colors.textColor};
`;
